import type {AppState,Position} from './model';
import {COURT} from '../../../../packages/domain/src/court';
import {findFaults} from '../../../../packages/domain/src/overlapRules';
import {resolve} from '../../../../packages/domain/src/phases';
import type {Spot} from '../../../../packages/domain/src/types';
export interface CourseProgress {version:2;step:number;position:Position;completed:boolean}
export function restoreProgress(value:unknown,position:Position):CourseProgress {
 const fresh:CourseProgress={version:2,step:0,position,completed:false};
 if(!value||typeof value!=='object')return fresh;
 const v=value as Partial<CourseProgress>;
 return v.version===2&&v.position===position&&Number.isInteger(v.step)&&v.step!>=0&&v.step!<8&&typeof v.completed==='boolean'?v as CourseProgress:fresh;
}
export function lessonSituation(step:number):Partial<AppState>{
 return {phase:step<3?'base':step<6?'serve':'defence',weServe:false,camera:'broadcast'};
}
export function gradePlacement(state:AppState,point:Spot){
 const resolved=resolve(state);const role=state.selectedRole??'S';const zone=resolved.roster.slots.get(role);const target=resolved.spots.get(role);
 if(zone===undefined||!target)return {kind:'bench' as const,legal:null,near:false,faults:[],distance:null};
 const byZone=new Map(resolved.byZone);byZone.set(zone,point);
 const bounded=Math.abs(point.x)<=COURT.halfWidth&&point.z>=0&&point.z<=COURT.halfDepth;
 const enforced=(state.phase==='base'||state.phase==='serve')&&!state.weServe;const faults=enforced?findFaults(byZone):[];
 return {kind:enforced?'receiving' as const:'tactical' as const,legal:enforced?bounded&&faults.length===0:null,near:Math.hypot(target.x-point.x,target.z-point.z)<1,distance:Math.hypot(target.x-point.x,target.z-point.z),faults};
}
